import { getIdByDate } from "@src/appV2/lib/Calendar/utils/getIdByDate";
import { CalendarGridMonth } from "@src/appV2/redesign/Calendar/GridMonth";
import { isSameDay } from "date-fns";

import { AvailabilityCalendarCell } from "./Cell";

const EMPTY_BLOCKED_DATES: Date[] = [];
const EMPTY_AVAILABLE_DATES: Date[] = [];

export interface AvailabilityCalendarProps {
  availableDates?: Date[];
  blockedDates?: Date[];
  isLoading?: boolean;
  currentDate: Date;
  onDateSelect: (props: {
    id: string;
    value: Date;
    isSelected: boolean;
    isDisabled: boolean;
  }) => void;
}

export function AvailabilityCalendar(props: AvailabilityCalendarProps) {
  const {
    currentDate,
    availableDates = EMPTY_AVAILABLE_DATES,
    blockedDates = EMPTY_BLOCKED_DATES,
    isLoading = false,
    onDateSelect,
  } = props;

  function isDateSelected(date: Date) {
    return availableDates.some((availableDate) => isSameDay(availableDate, date));
  }

  function isDateBlocked(date: Date) {
    return blockedDates.some((blockedDate) => isSameDay(blockedDate, date));
  }

  return (
    <CalendarGridMonth
      showMonthTitle={false}
      startDate={currentDate}
      weekSpacing={4}
      renderDateCell={(date) => {
        const isDisabled = isDateBlocked(date);
        const isSelected = isDateSelected(date);
        return (
          <AvailabilityCalendarCell
            isDisabled={isDisabled}
            isLoading={isLoading}
            date={date}
            isSelected={isSelected}
            onToggleSelect={() => {
              onDateSelect({
                id: getIdByDate(date),
                value: date,
                isSelected,
                isDisabled,
              });
            }}
          />
        );
      }}
      renderPastCell={(date) => (
        <AvailabilityCalendarCell
          isDisabled
          isLoading={isLoading}
          date={date}
          isSelected={isDateSelected(date)}
        />
      )}
    />
  );
}
